import React, { useMemo } from 'react';
import { Image } from 'react-native';
import { createStyleSheet, UnistylesRuntime, useStyles } from 'react-native-unistyles';
import { WindowInformation } from '../services/window-information';

function getLogo(isSmartSampa: boolean, isMobile: boolean) {
    if (isSmartSampa) {
        if (isMobile) {
            if (UnistylesRuntime.themeName === 'dark') {
                return require('../../assets/big_smartsampa_logo_mobile_dark.png');
            } else {
                return require('../../assets/big_smartsampa_logo_mobile_light.png');
            }
        } else {
            if (UnistylesRuntime.themeName === 'dark') {
                return require('../../assets/big_smartsampa_logo_dark.png');
            } else {
                return require('../../assets/big_smartsampa_logo_light.png');
            }
        }
    }
    if (UnistylesRuntime.themeName === 'dark') {
        return require('../../assets/SentinelX_logo_dark.png');
    } else {
        return require('../../assets/SentinelX_logo_light.png');
    }
}

export default function SentinelXLogo() {
    const isSmartSampa = useMemo(() => window.location.hostname.includes('smartsampa'), [window.location]);
    const { isMobile } = WindowInformation();

    const { styles } = useStyles(stylesheet);
    return <Image style={styles.image(isSmartSampa, isMobile)} source={getLogo(isSmartSampa, isMobile)} />;
}

const stylesheet = createStyleSheet(() => ({
    image: (isSmartSampa: boolean, isMobile: boolean) => ({
        width: isSmartSampa && isMobile ? 236 : '100%',
        resizeMode: 'contain',
        height: '100%',
    }),
}));
